import * as React from 'react';
import Styled from 'styled-components';

export const SelectOption = Styled.option`
  color: #000;
`;

export class Option extends React.PureComponent<React.AllHTMLAttributes<HTMLOptionElement>> {
  public render () {
    const { children, ...restProps } = this.props;

    return <SelectOption aria-selected={restProps.checked}>{children}</SelectOption>;
  }
}

SelectOption.displayName = 'SelectOption';

export default SelectOption;
